export default {
  BRAND_NAME_EN: "AUREASTONE",
  BRAND_NAME_CN: "欧若拉",
  TABLE_SIZE: 10,
  VERSION: "0.1.0"
};
